/**
 * Dealer slug and profile href helpers (Dealer Profile M2).
 */
import { runtimeDealerProfilePath } from "../../clientViewRuntime/utils/routes";

const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function normalizeDealerSlug(value) {
  if (value == null || value === "") return null;
  const trimmed = String(value).trim().toLowerCase();
  if (!trimmed) return null;
  if (SLUG_PATTERN.test(trimmed)) return trimmed;
  const slugified = trimmed
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");
  return slugified && SLUG_PATTERN.test(slugified) ? slugified : null;
}

export function isValidDealerSlug(slug) {
  return Boolean(slug && SLUG_PATTERN.test(String(slug)));
}

export function buildDealerSlug(dealer = {}) {
  const existing = normalizeDealerSlug(dealer.slug || dealer.dealerSlug);
  if (existing) return existing;
  const name = dealer.name || dealer.businessName || dealer.dealerName;
  const fromName = name ? normalizeDealerSlug(name) : null;
  if (fromName) return fromName;
  const id = dealer.id || dealer.dealerId;
  if (id) {
    const fromId = normalizeDealerSlug(String(id));
    if (fromId) return fromId;
  }
  return null;
}

/**
 * @param {import('./dealerProfileTypes').DealerProfile|null|undefined} dealer
 * @param {{ slug?: string, usePublicRoute?: boolean }} [options]
 */
export function getDealerProfileHref(
  dealer,
  { slug = "automap", usePublicRoute = true, locale = null } = {}
) {
  const dealerSlug = dealer?.slug || buildDealerSlug(dealer);
  if (!isValidDealerSlug(dealerSlug)) return null;
  if (usePublicRoute !== false) {
    return runtimeDealerProfilePath(slug, dealerSlug, locale);
  }
  return runtimeDealerProfilePath(slug, dealerSlug, locale);
}
